import React from "react";
import { useState } from "react";
import { Container } from "react-bootstrap";
import Dialog from "./Dialog";
import GameCard from "./GameCard";

function GameCardsWrapper() {
  // Declaring items app state
  const [items, setItems] = useState(
    [
      { id: 1, img: "/images/gold.png", value: "WIN!", stat: "" },
      { id: 2, img: "/images/dragon.png", value: "LOSE!", stat: "" },
      { id: 3, img: "/images/dragon.png", value: "LOSE!", stat: "" },
    ].sort(() => Math.random() - 0.5)
  );

  // Declaring dialog state
  const [dialog, setDialog] = useState({
    message: "text something",
    isLoading: false,
  });

  // Dialog buttons onClick actions
  const playAgain = (choice) => {
    if (!choice) {
      // removing Dialog component.
      setDialog(false);
      // shuffling cards.
      setItems([...items].sort(() => Math.random() - 0.5));
      // for some reason my shuffle code has issues on chrome.
      // setItems([...items].sort(() => Math.floor(Math.random() * items.length)));
    } else {
      window.location.href = "/";
    }
  };

  /*card onClick actions
  The function below handles most of the logic for the game.
  Onclick we get the id/index of the element then the "if" block checks the "items[id].value" card 
  if the "items[id].value" is === win the css classes of "active" is added
  to the "item.stat" to flip the card including the "correct" class to change the background to green
  followed by a setTimeout function to setDialog state the "else" block
  does the same as stated above but in revers "win" will be "lose", "correct" class
  will be "wrong".*/
  function handleClick(id) {
    setItems([...items]);
    if (items[id].value === "WIN!") {
      items[id].stat = "active correct";
      // setTimeout here
      setTimeout(() => {
        setDialog({
          message: "Congratulations YOU WIN!!!, Play Again?  ⚔️",
          isLoading: true,
        });
        items[id].stat = "";
        setItems([...items]);
      }, 1200);
    } else {
      items[id].stat = "active wrong";
      // setTimeout here
      setTimeout(() => {
        setDialog({
          message: "YOU LOSE!!!, Try Again?  ⚰️",
          isLoading: true,
        });
        items[id].stat = "";
        setItems([...items]);
      }, 1200);
    }
  }

  // the code below is the wrapper for the GameCard components
  return (
    <div>
      <Container>
        {/* mapping items into GameCard component and passing props to be displayed on the cards */}
        {items.map((item, index) => (
          <GameCard
            key={index}
            item={item}
            id={index}
            handleClick={handleClick}
          />
        ))}
      </Container>
      {/* including Dialog component to the app */}
      {dialog.isLoading && (
        <Dialog message={dialog.message} onDialog={playAgain} />
      )}
    </div>
  );
}

export default GameCardsWrapper;
